import Swiper from './Reviews/View';

export default Swiper;
